/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1PersonId202,
  DeleteApiV1PersonId401,
  DeleteApiV1PersonId404,
  DeleteApiV1PersonId500,
  DeleteApiV1PersonIdMutationResponse,
  DeleteApiV1PersonIdPathParams,
} from "../../types/personRegisterController/DeleteApiV1PersonId.ts";

export const deleteApiV1PersonIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<DeleteApiV1PersonIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const deleteApiV1PersonId202Schema =
  z.any() as unknown as ToZod<DeleteApiV1PersonId202>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1PersonId401Schema =
  z.any() as unknown as ToZod<DeleteApiV1PersonId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1PersonId404Schema =
  z.any() as unknown as ToZod<DeleteApiV1PersonId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1PersonId500Schema =
  z.any() as unknown as ToZod<DeleteApiV1PersonId500>;

export const deleteApiV1PersonIdMutationResponseSchema = z.lazy(
  () => deleteApiV1PersonId202Schema,
) as unknown as ToZod<DeleteApiV1PersonIdMutationResponse>;
